import { LayoutNotificationDropdownConfig } from './layout-notifications.model';

export const LAYOUT_NOTIFICATION_DROPDOWN_CONFIG: { [priorityId: number]: LayoutNotificationDropdownConfig } = {
    [1]: {
        icon: 'error',
        baseColor: 'hsla(0, 65%, 51%, 1)',
    },
    [2]: {
        icon: 'warning',
        baseColor: 'hsla(30, 80%, 50%, 1)',
    },
    [3]: {
        icon: 'notifications',
        baseColor: 'hsla(180, 87%, 40%, 1)',
    },
};
